var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow rounded py-2 px-4"},[_c('span',{staticClass:"text-lil font-semibold font-display1 text-gray-dark"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"flex items-center text-lg text-tozny"},[_c('i',{staticClass:"material-icons micon mr-2"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }